import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { IoWarning, IoCloseCircleOutline } from 'react-icons/io5';
import { GiCheckMark } from "react-icons/gi";
import { MdOutlineTimer } from 'react-icons/md';
import {
    RiAddBoxLine,
    RiCheckboxCircleFill,
    RiFileEditLine
} from 'react-icons/ri';
import TestsVector from 'assets/vectors/Tests.svg';
import Helmet from 'components/Helmet';
import Button from 'components/Button';
import axios from 'config/axios';
import { Bundle, Test } from 'global/types';
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
import { updateCart } from 'store/cart';
import { setAlert } from 'store/error';
import './index.css';

type newTestsProps = {
    testType: string;
    // tests: Test[];
    bundles: Bundle[];
    // numTests: number;
};

function Bundles({ testType, bundles }: newTestsProps) {
    // const [selectedBundles, setSelectedBundles] = useState([]);

    const { user } = useAppSelector(state => state.user);
    const { bundles: cartBundles } = useAppSelector(state => state.cart);

    const dispatch = useAppDispatch();

    const refreshCart = () => {
        axios.get('payments/cart/')
            .then(res => {
                // console.log(res.data);
                dispatch(updateCart({
                    bundles: res.data?.cartBundles,
                }));
            });
    }

    const addToCart = (bundle) => {
        axios.post(`payments/cart/add/bundle/${bundle.id}/`)
            .then(res => {
                // let newSelectedBundles = [...selectedBundles, bundle];
                // setSelectedBundles(newSelectedBundles);
                refreshCart();
            })
            .catch(error => {
                console.log(error);
            });
    }

    return (
        <div className='newTests'>
            {/* <div className='newTests__available'>
                <img className='newTests__availableVector' src={TestsVector} alt='Tests' />
                <h2 className='newTests__availableText'><span>{tests.length}</span> / {numTests} tests available</h2>
            </div> */}
            <div className='newTests__plan'>
                <div className='newTests__planInfo'>
                    <h4 className='newTests__planInfoText'>
                        Current Plan: {user.bundle
                            ? <b className='newTests__planInfoPremium'>{user.bundle.name}</b>
                            : <b>Diagnostic Starter</b>
                        }
                    </h4>
                    <div className={user.bundle ? 'newTests__premium' : 'newTests__free'}>
                        <p>{user.bundle ? 'Premium' : 'Free'}</p>
                    </div>
                </div>
                
                {user.bundle
                ?   <p className='newTests__expiration'>
                        <MdOutlineTimer /> &nbsp;active until {new Date(user.bundle.expirationDate).toLocaleDateString()}
                    </p>
                :   <div className='newTests__warning'>
                        <IoWarning className='newTests__warningIcon' />
                        <p className='newTests__warningText'>
                            Please ask your tutor about if/when to upgrade your account.
                        </p>
                    </div>
                }
            </div>
            
            {!user.bundle && <>
                <h4 className='newTests__subHeader'>Plan Options</h4>
                <div className='newTests__pricing'>
                    <div className='newTests__pricingBox'>
                        <div className='newTests__pricingHeaderFree'>
                            <h3>Diagnostic Starter</h3>
                        </div>
                        <h4 className='newTests__pricingName'>Unlimited Free Trial</h4>
                        <div className='newTests__priceTagFree'>
                            <p className='newTests__priceDescription'>Student Account</p>
                            <b className='newTests__price'>$0</b>
                            <p className='newTests__priceDescriptionSmall'>No credit card required</p>
                        </div>
                        <div className='newTests__pricingDescription'>
                            <GiCheckMark className='newTests__pricingDescriptionIcon' />
                            <p className='newTests__pricingDescriptionText'>Connected to your tutor</p>
                        </div>
                        <div className='newTests__pricingDescription'>
                            <GiCheckMark className='newTests__pricingDescriptionIcon' />
                            <p className='newTests__pricingDescriptionText'>1 SAT & 1 ACT diagnostic</p>
                        </div>
                    </div>
                    <div className='newTests__pricingBox'>
                        <div className='newTests__pricingHeaderPremium'>
                            <h3>Strategic Crammer</h3>
                        </div>
                        <h4 className='newTests__pricingName'>30-day Access</h4>
                        <div className='newTests__priceTagPremium'>
                            <p className='newTests__priceDescription'>Student Account</p>
                            <b className='newTests__price'>$49.99</b>
                            <p className='newTests__priceDescriptionSmall'>&nbsp;</p>
                        </div>
                        <div className='newTests__pricingDescription'>
                            <GiCheckMark className='newTests__pricingDescriptionIcon' />
                            <p className='newTests__pricingDescriptionText'>Connected to your tutor</p>
                        </div>
                        <div className='newTests__pricingDescription'>
                            <GiCheckMark className='newTests__pricingDescriptionIcon' />
                            <p className='newTests__pricingDescriptionText'>Over 30 practice tests</p>
                        </div>
                        <div className='newTests__pricingDescription'>
                            <GiCheckMark className='newTests__pricingDescriptionIcon' />
                            <p className='newTests__pricingDescriptionText'>SAT, PSAT, & ACT exams</p>
                        </div>
                        <div className='newTests__pricingDescription'>
                            <GiCheckMark className='newTests__pricingDescriptionIcon' />
                            <p className='newTests__pricingDescriptionText'>Detailed post-test reports</p>
                        </div>
                        {cartBundles.some(bundle => bundle.name === 'Strategic Crammer')
                        ?   <Button
                                className='newTests__pricingButton'
                                disabled
                            >
                                Added to Cart
                            </Button>
                        :   <Button
                                className='newTests__pricingButton'
                                secondary
                                onClick={() => addToCart(bundles.find(bundle => bundle.name === 'Strategic Crammer'))}
                            >
                                Add to Cart
                            </Button>
                        }
                    </div>
                    <div className='newTests__pricingBoxPopular'>
                        <div className='newTests__pricingHeaderPopular'>
                            <h3>Steady Prepper</h3>
                            <div className='newTests__pricingHeaderTag'>
                                <p>MOST POPULAR</p>
                            </div>
                        </div>
                        <h4 className='newTests__pricingNamePopular'>Yearly Access</h4>
                        <div className='newTests__priceTagPopular'>
                            <p className='newTests__priceDescription'>Student Account</p>
                            <b className='newTests__price'>$24.99<span>/mo</span></b>
                            <p className='newTests__priceDescriptionSmall'>Billed at $299.99</p>
                            <h6 className='newTests__priceDescriptionPopular'>Equivalent to 6 months free!</h6>
                            <div className='newTests__priceTagHighlight'><h6>SAVE<br/>50%</h6></div>
                        </div>
                        <div className='newTests__pricingDescription'>
                            <GiCheckMark className='newTests__pricingDescriptionIcon' />
                            <p className='newTests__pricingDescriptionText'>Connected to your tutor</p>
                        </div>
                        <div className='newTests__pricingDescription'>
                            <GiCheckMark className='newTests__pricingDescriptionIcon' />
                            <p className='newTests__pricingDescriptionText'>Over 30 practice tests</p>
                        </div>
                        <div className='newTests__pricingDescription'>
                            <GiCheckMark className='newTests__pricingDescriptionIcon' />
                            <p className='newTests__pricingDescriptionText'>SAT, PSAT, & ACT exams</p>
                        </div>
                        <div className='newTests__pricingDescription'>
                            <GiCheckMark className='newTests__pricingDescriptionIcon' />
                            <p className='newTests__pricingDescriptionText'>Detailed post-test reports</p>
                        </div>
                        <div className='newTests__pricingDescription'>
                            <GiCheckMark className='newTests__pricingDescriptionIcon' />
                            <p className='newTests__pricingDescriptionText'>Priority access to new tests & features</p>
                        </div>
                        {cartBundles.some(bundle => bundle.name === 'Steady Prepper')
                        ?   <Button
                                className='newTests__pricingButton'
                                disabled
                            >
                                Added to Cart
                            </Button>
                        :   <Button
                                className='newTests__pricingButton'
                                secondary
                                onClick={() => addToCart(bundles.find(bundle => bundle.name === 'Steady Prepper'))}
                            >
                                Add to Cart
                            </Button>
                        }
                    </div>
                    <div className='newTests__pricingBox'>
                        <div className='newTests__pricingHeaderPremium'>
                            <h3>Lifelong Learner</h3>
                        </div>
                        <h4 className='newTests__pricingName'>Lifetime Access</h4>
                        <div className='newTests__priceTagPremium'>
                            <p className='newTests__priceDescription'>Student Account</p>
                            <b className='newTests__price'>$999.99</b>
                            <p className='newTests__priceDescriptionSmall'>&nbsp;</p>
                        </div>
                        <div className='newTests__pricingDescription'>
                            <GiCheckMark className='newTests__pricingDescriptionIcon' />
                            <p className='newTests__pricingDescriptionText'>Connected to your tutor</p>
                        </div>
                        <div className='newTests__pricingDescription'>
                            <GiCheckMark className='newTests__pricingDescriptionIcon' />
                            <p className='newTests__pricingDescriptionText'>Over 30 practice tests</p>
                        </div>
                        <div className='newTests__pricingDescription'>
                            <GiCheckMark className='newTests__pricingDescriptionIcon' />
                            <p className='newTests__pricingDescriptionText'>SAT, PSAT, & ACT exams</p>
                        </div>
                        <div className='newTests__pricingDescription'>
                            <GiCheckMark className='newTests__pricingDescriptionIcon' />
                            <p className='newTests__pricingDescriptionText'>Detailed post-test reports</p>
                        </div>
                        <div className='newTests__pricingDescription'>
                            <GiCheckMark className='newTests__pricingDescriptionIcon' />
                            <p className='newTests__pricingDescriptionText'>Priority access to new tests & features</p>
                        </div>
                        {cartBundles.some(bundle => bundle.name === 'Lifelong Learner')
                        ?   <Button
                                className='newTests__pricingButton'
                                disabled
                            >
                                Added to Cart
                            </Button>
                        :   <Button
                                className='newTests__pricingButton'
                                secondary
                                onClick={() => addToCart(bundles.find(bundle => bundle.name === 'Lifelong Learner'))}
                            >
                                Add to Cart
                            </Button>
                        }
                    </div>
                </div>
            </>}
            {/* {bundles.length > 0 && <>
                <h4 className='newTests__subHeader'>Plan Options</h4>
                <div className='newTests__bundles'>
                    {bundles.map(bundle => (
                        <div className='newTests__bundle' key={bundle.id}>
                            <div className='newTests__inline'>
                                <RiFileEditLine className='newTests__testIcon' />
                                <p className='newTests__boldText'>
                                    {bundle.name}
                                </p>
                            </div>
                            <p className='newTests__description'>
                                full access to {bundle.tests.length} tests
                            </p>
                            <div className='newTests__inline'>
                                {bundle.discount &&
                                    <p className='newTests__originalPrice'>
                                        ${bundle.price.toFixed(2)}
                                    </p>
                                }
                                <p className='newTests__boldText'>
                                    ${(bundle.discount?.type === 'Amount'
                                        ?   bundle.price - bundle.discount.value
                                        :   bundle.discount?.type === 'Percent'
                                        ?   bundle.price * (100 - bundle.discount.value) / 100
                                        :   bundle.price
                                    ).toFixed(2)}
                                </p>
                            </div>
                            {cartBundles.map(bundle => bundle.id).includes(bundle.id)
                            ?   <Button
                                    className='newTests__button'
                                    disabled
                                >
                                    ADDED TO CART
                                </Button>
                            :   <Button
                                    className='newTests__button'
                                    onClick={() => addToCart(bundle)}
                                >
                                    ADD TO CART
                                </Button>
                            }
                        </div>
                    ))}
                </div>
            </>} */}
        </div>
    );
}

export default Bundles;